import React from "react";
import { get, isEmpty } from "lodash";
import { TableRow, TableCell } from "@material-ui/core";
import { VIDEO_SECTION } from "../../../constants/ContentFinder";
import { displayData, hasAnyValue } from "../../../utils/ContentFinderUtils";
import DrawerTable from "./DrawerTable";

const VideoSection = ({ videoTracks, versionCreatedAt }) => {
  const tracks = [...videoTracks]
    .filter((track) => {
      const properties = get(track, "properties", {});
      const width = get(properties, "width");
      const height = get(properties, "height");
      return hasAnyValue([
        get(properties, "videoType"),
        get(properties, "subType"),
        get(properties, "frameRate"),
        get(properties, "aspectRatio"),
        width && height ? `${width}x${height}` : null,
        get(properties, "scanType"),
        get(properties, "writtenLanguage") ||
          get(properties, "burnedInSubtitles"),
        get(properties, "duration"),
        get(track, "dateAdded") || versionCreatedAt,
      ]);
    })
    .sort((a, b) => (a.trackNum || 0) - (b.trackNum || 0));

  return (
    <DrawerTable
      title={VIDEO_SECTION.title}
      headers={VIDEO_SECTION.headers}
      isEmpty={isEmpty(tracks)}
      emptyMessage={VIDEO_SECTION.emptyMessage}
    >
      {tracks.map((track, i) => {
        const properties = get(track, "properties", {});
        const width = get(properties, "width");
        const height = get(properties, "height");

        let isBCP47 = true;
        let burnedInSubtitles = get(properties, "writtenLanguage");
        if (!burnedInSubtitles) {
          isBCP47 = false;
          burnedInSubtitles = get(properties, "burnedInSubtitles");
        }

        return (
          <TableRow key={i} className="tableRow content-finder-body-row">
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "videoType"), { titleCase: true })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "subType"), { titleCase: true })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "frameRate"))}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "aspectRatio"))}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(`${width} x ${height}`, {
                expression: width && height,
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "scanType"), { titleCase: true })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(burnedInSubtitles, {
                displayLanguage: true,
                displayFallback: "None",
                isBCP47,
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "duration"), {
                formatDuration: true,
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(track, "dateAdded") || versionCreatedAt, {
                dateFormat: "YYYY-MM-DD",
              })}
            </TableCell>
          </TableRow>
        );
      })}
    </DrawerTable>
  );
};

export default VideoSection;
